module.exports = __webpack_public_path__ + "static/media/portfolio_pic.ee9e72cf.jpg";